import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack,
  FDImage,
  FDPrimaryActionButton,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { dataAttrs } from 'Helpers/Testing';
import {
  useBuildCommonFQEventProperties,
} from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import fr from 'facet-rest';
import ChiliPiperConciergeComponentPicker from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperConciergeComponentPicker';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import EmbeddedSalesforceChatForEQF
  from 'Views/Onboarding/Components/HeaderBar/PlannerChat/EmbeddedSalesforceChatForEQF';
import { QueryVal } from 'Helpers/Query';

const InsightSchedule = () => {
  const { resource, onSubmit } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  useScrollTopOnMount();
  useBoneBackgroundColor();

  // Check for action=schedule-meeting query parameter to auto-trigger phone modal
  const shouldAutoTriggerPhone = () => {
    const action = QueryVal('action');
    return action === 'schedule-meeting';
  };

  return (
    <QuizWrapperLayout>
      <FDStack direction={'column'} spacing={4} {...dataAttrs('insight-container')}>
        <FDStack direction={'column'} spacing={2}>
          <FDStack direction={'column'} spacing={2}>
            {resource.withRelationship(fr.relationships.image.name,
              (rel) => (
                <FDStack direction={'column'} paddingY={4}>
                  <FDImage
                    src={rel.link('related').url()}
                    alt={rel.meta('altText') || ''}
                    aspectRatio={rel.meta('aspectRatio')}
                  />
                </FDStack>),
              () => null)}
            <MetaControlField attr={'title'} />
            <MetaControlField attr={'insightDescription'} />
          </FDStack>
          {resource.meta().canPut()
            && <FDPrimaryActionButton
              onClick={() => {
                logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
                  eventProperties: {
                    ...buildCommonFQEventProperties(resource),
                    insightId: resource.attr('insightId'),
                    insightReferenceName: resource.attr('insightReferenceName'),
                    isPrimaryAction: true,
                  },
                });
                onSubmit();
              }}
              isFullWidth
              {...dataAttrs('primary-action-button')}
              label={'Continue'}
            />
          }
          {resource.withRelationship(fr.relationships.scheduleChiliPiperMeetingMM.name,
            (rel) => {
              return (
                <FDStack direction={'column'} alignItems={'center'} width={'100%'} spacing={2}>
                  <ChiliPiperConciergeComponentPicker
                    relationship={rel}
                    quizId={resource.attr('quizId') || ''}
                    shouldShowMMButton
                    shouldAutoTriggerPhone={shouldAutoTriggerPhone()}
                    onSchedulingSuccess={() => {
                      logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
                        eventProperties: {
                          ...buildCommonFQEventProperties(resource),
                          insightId: resource.attr('insightId'),
                          insightReferenceName: resource.attr('insightReferenceName'),
                          action: 'schedule_chilipiper_meeting',
                        },
                      });
                    }}
                    resource={resource}
                  />
                </FDStack>
              );
            },
            () => null)}
          {resource.withRelationship(fr.relationships.scheduleChiliPiperMeetingMA.name,
            (rel) => {
              return (
                <FDStack direction={'column'} alignItems={'center'} width={'100%'} spacing={2}>
                  <ChiliPiperConciergeComponentPicker
                    shouldShowMMButton={false}
                    relationship={rel}
                    shouldAutoTriggerPhone={shouldAutoTriggerPhone()}
                    resource={resource}
                    onSchedulingSuccess={() => {
                      logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
                        eventProperties: {
                          ...buildCommonFQEventProperties(resource),
                          insightId: resource.attr('insightId'),
                          insightReferenceName: resource.attr('insightReferenceName'),
                          action: 'schedule_chilipiper_meeting',
                        },
                      });
                    }}
                  />
                </FDStack>
              );
            },
            () => null)}
          {resource.withRelationship(fr.relationships.eqfChat.name, () => (
            <EmbeddedSalesforceChatForEQF resource={resource} />
          ), () => null)}
        </FDStack>
      </FDStack>
    </QuizWrapperLayout>
  );
};

export { InsightSchedule };
